// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"41582750","97":"41582750","110":"41582750","138":"41582750","163":"41582750","228":"41582750","254":"41582750","262":"41582750","817":"41582750","821":"41582750","930":"41582750"}[chunkId] + ".chunk.css";
};